import { render, staticRenderFns } from "./ModalPayment.vue?vue&type=template&id=bd995fc2&lang=pug&"
import script from "./ModalPayment.vue?vue&type=script&lang=js&"
export * from "./ModalPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalPayment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports